import Switch from "@components/inputs/switch";
import styled from "styled-components";

import { T_PLAIN_big_hig } from "../../../global.style";

export const SavingsHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
`;

export const SavingsText = styled.span`
    white-space: nowrap;
    ${T_PLAIN_big_hig};
    text-transform: uppercase;
`;

export const SavingsButton = styled(Switch)`
  white-space: nowrap;
`;

export const SavingsLine = styled.div`
  flex-grow: 1;
  height: 1px;
  background-color: ${props =>props.theme.C_FORM_GROUP_HEADER_LINE};
`;

export const SavingsRow = styled.div `
    margin: 20px 0;
    width: 100%;
`;

export const SavingsBody = styled.div `
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const SavingsFields = styled.div `
    margin-top: 25px;
    row-gap: 17px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-end;
    flex-grow: 1;
`;